module.exports = __webpack_public_path__ + "img/unlock-lockup.4a8e4d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unlock-lockup.svg
// module id = Y3p5
// module chunks = 1